import moment from "moment";
import { setActiveAccount, setActiveStore } from "@bigyellow/libs/customer";
import { redirect } from "@bigyellow/libs/redirect";
import * as Urls from "@bigyellow/routes";

const Reservation = ({ reservation, activeStore, account }) => {
  return (
    <div className={`d-flex text-xs`}>
      {account.reservations.length > 1 &&
        <span className={`unit-number mr-2`}>
        Room no {reservation.unitNumber}
      </span>
      }
      <span className={`move-in-date mr-2`}>
        Storage start date: {moment(reservation.proposedRentalDate).format("DD/MM/YYYY")}
      </span>
      <a href={`#!`}
         className={`text-dark ml-auto`}
         style={{ textDecoration: "underline" }}
         onClick={(e) => {
           e.preventDefault();
           setActiveStore(activeStore).then(() => {
             setActiveAccount(account).then(() => {
               redirect(Urls.MOVE_IN_DATE_CHANGE.replace("{reservation_id}", reservation.reservationId));
             });
           });
         }}>
        Change date
      </a>
    </div>
  );

};
export const DashboardMoveInDetails = ({ account, activeStore }) => {

  if (account.reservations === null || account.reservations === undefined || account.reservations.length === 0)
    return <></>;

  return (
    <div className={`card-footer dashboard-change-date bg-white mt-0`}>
      {
        account.reservations.map((reservation, index) => {
          return <Reservation key={index}
                              reservation={reservation}
                              activeStore={activeStore}
                              account={account}
          />;
        })
      }
    </div>
  );
};